export interface DecedentValidationRequest {
  decedentPoid: string;
  zipCode: string;
  addressLine1: string;
  city: string;
  stateCode: string;
  dateOfBirth: string;
}

export interface DecedentValidationResponse {
  valid: boolean;
  external: boolean;
  failureReasons?: string[];
}

export interface DecedentAccountsRequest {
  ssn: string;
}
